<template>
  <!-- 导入Excel -->
  <el-upload
    action="https://wechat.caiii.cn/site/poi/web/waterTicket/importData"
    :headers="headers"
    :on-change="onChange"
    :auto-upload="true"
    :show-file-list="false"
    accept=".xls, .xlsx" >
    <el-button type="warning" icon="el-icon-folder-add">批量导入</el-button>
  </el-upload>
</template>

<script>
export default {
  data() {
    return {
      headers:{}
    };
  },
  methods: {
    // ----------以下为导入Excel数据功能--------------
    // 文件选择回调
    onChange(file, fileList) {
      console.log(fileList);
      this.fileData = file; // 保存当前选择文件
      this.readExcel(); // 调用读取数据的方法
    },
    // 读取数据
    readExcel(e) {
      console.log(e);
      let that = this;
      const files = that.fileData;
      console.log(files);
      if (!files) {
        //如果没有文件
        return false;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          // console.log(data)
          const workbook = this.XLSX.read(data, {
            type: "binary"
          });
          console.log(workbook.SheetNames);
          if (workbook.SheetNames.length >= 1) {
            this.$message({
              message: "导入数据表格成功",
              showClose: true,
              type: "success"
            });
          }
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = this.XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
          console.log(ws);
          that.outputs = []; //清空接收数据
          for (var i = 0; i < ws.length; i++) {
            var sheetData = {
              // 键名为绑定 el 表格的关键字，值则是 ws[i][对应表头名]
              name: ws[i]["水票名称"],
              id: ws[i]["商品id"],
              stuName: ws[i]["商品名称"],
              stuNumber: ws[i]["购买的总数量"],
              shNumber: ws[i]["剩余的数量"],
              building: ws[i]["楼栋名称"],
              address: ws[i]["房间号"],
              siteId: ws[i]["水站id"],
              receiveContact: ws[i]["收货人联系方式"],
              buyerName: ws[i]["收货人"]
            };
            that.studentlist.unshift(sheetData);
          }
          this.$refs.upload.value = "";
        } catch (e) {
          return false;
        }
      };
      // 如果为原生 input 则应是 files[0]
      fileReader.readAsBinaryString(files.raw);
    },
  },
  created(){
    this.headers ={Authorization : location.href.split('?token=')[1]}
  },
  computed: {
  },
};
</script>

<style lang='scss' scoped>
.regist_body{
  max-width: 1200px;
  margin: 60px auto;
  background: #ffffff;
  .header{
    padding: 0 40px;
    height: 68px;
    line-height: 68px;
    border-bottom: 1px solid #c4c4c4;
    .title{
      float: left;
    }
    .backToLogin{
      float: right;
      color: #666666;
    }
    .backToLogin:hover{
      text-decoration: underline;
    }
  }
  .body{
    text-align: center;
    padding: 60px 0;
    .tip{
      .logo, .title{
        display: inline-block;
        vertical-align: middle;
      }
      .title{
        margin-left: 12px;
        font-size: 18px;
        font-weight: 600;
      }
    }
    .options{
      margin-top: 40px;
      .self{
        background: #FF4500;
        border-color: #FF4500;
        color: #ffffff;
      }
      .self:hover{
        background: #ffffff;
        border-color: #FF4500;
        color: #FF4500;
      }
      .index{
        border-color: #FF4500;
        color: #FF4500;
      }
      .index:hover{
        background: #FF4500;
        border-color: #FF4500;
        color: #ffffff;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/auth/UpDome.vue